import isEmpty from 'lodash/isEmpty'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { RouteComponentProps, withRouter } from 'react-router-dom'

import { LOCIZE_NAMESPACE } from 'main/common'
import {
  initialParams,
  validate,
} from 'main/components/common/AuthModal/parent/InitialParentSignUpForm/Fields'
import {
  IParams,
  IValidation,
} from 'main/components/common/AuthModal/parent/InitialParentSignUpForm/types'
import {
  getParentJoinUrl,
  getWhitelabelBranding,
} from 'main/components/common/AuthModal/ssoNavigation'
import Form from 'main/components/common/Form'
import { useWhitelabel } from 'main/framework'
import useSSOContext from 'main/hooks/useSSOContext'
import { i18nKeyPrefix } from 'main/pages/Search/i18n'
import { TextField } from 'main/ui'
import { buildTracking } from 'main/util/ssoRouting'
import { UserSignUpSource, UserType } from 'main/util/user'
import segment from 'util/analytics/segment'

import { FORM_STATE_KEY } from '@wonderschool/common-base-sso'

import { Container, StyledButton, StyledTerms, TitleText } from './LoggedOutFrom.styles'

interface IProps extends RouteComponentProps {
  loggedOutTitle: string
}

const PRE = `${i18nKeyPrefix}-SAVE-LOGGED-OUT`

function LoggedOutForm(props: IProps) {
  const { loggedOutTitle, location } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  const [params, setParams] = React.useState<IParams>(initialParams())
  const [validation, setValidation] = React.useState<IValidation>({})
  const [loading, setLoading] = React.useState<boolean>(false)

  const { extendNavContext } = useSSOContext() // this page doesn't set its own nav context but might pass along some
  const whitelabel = useWhitelabel()

  return (
    <div>
      <TitleText>{loggedOutTitle}</TitleText>
      <Form onSubmit={() => handleSubmit()}>
        <Container>
          <TextField
            label={t(`${PRE}-NAME-LABEL`)}
            placeholder={t(`${PRE}-NAME-PLACEHOLDER`)}
            value={params.firstName}
            onChange={firstName => handleChange({ firstName })}
            validationHint={validation.firstName}
            required
          />
          <TextField
            label={t(`${PRE}-EMAIL-LABEL`)}
            placeholder={t(`${PRE}-EMAIL-PLACEHOLDER`)}
            value={params.email}
            onChange={email => handleChange({ email })}
            validationHint={validation.email}
            required
          />
          <StyledButton kind={'regular'} disabled={loading} small={false} full>
            {t(`${PRE}-SUBMIT`)}
          </StyledButton>
        </Container>
      </Form>
      <StyledTerms />
    </div>
  )
  function handleSubmit() {
    const validationResult = validate(params)

    setValidation(validationResult)
    if (!isEmpty(validationResult)) {
      return
    }

    setLoading(true)
    const newNavContext = extendNavContext({
      route: location.pathname,
    })

    const { email, firstName } = params
    segment.track('New Parent Lead', {}, undefined, () => {
      const parentJoinUrl = getParentJoinUrl(
        buildTracking(
          UserType.Parent,
          UserSignUpSource.ParentSaveSearchInlineForm,
          'Save Search Inline Form Completed Sign Up',
        ),
        newNavContext,
        {
          ...getWhitelabelBranding(whitelabel),
          [FORM_STATE_KEY]: {
            email: email.trim(),
            firstName: firstName.trim(),
          },
        },
      )
      window.location.replace(parentJoinUrl)
    })
  }

  function handleChange(changes: Partial<IParams>) {
    setParams(parameters => ({ ...parameters, ...changes }))
  }
}

export default withRouter(LoggedOutForm)
